import DescriptionIcon from '@/assets/icons/edit-document-white.svg?react';
import { Header } from '@/components/Header';
import './ServiceReservationGuide.scss';

export function PrivacyPolicyRequiredGuide() {
    return (
        <div className="service-reservation-guide-page">
            <Header />

            <main className="service-reservation-guide-main">
                <div className="service-reservation-guide-card">
                    <div
                        className="service-reservation-guide-card__icon"
                        style={{ backgroundColor: '#475569' }}
                    >
                        <DescriptionIcon className="icon-svg" />
                    </div>
                    <h1>개인정보 처리방침 안내</h1>
                    <p>시행 중인 개인정보 처리방침이 없습니다. 관리자에게 문의해주세요.</p>
                </div>
            </main>
        </div>
    );
}
